import { fromFetch } from 'rxjs/fetch';
import { FleetJwtAuthHeaders } from '../../models/fleet-jwt-auth-headers';
import { PagedCollectionParams } from '../../models/paged-collection-params';
import { requiredHeaders } from '../../models/required-headers';
import { selectData } from '../../utils/select-data';
import { fleetEnvironment } from './fleet-environment';
import { driverPagedCollectionSchema } from './schemas/driver-paged-group-paged-collection';

export function getDrivers(params?: PagedCollectionParams) {
  const requestUrl = `${fleetEnvironment.driversUrl}?${
    params ? params.urlParams : ''
  }`;
  return fromFetch(
    new Request(requestUrl, {
      method: 'GET',
      headers: {
        ...requiredHeaders,
        ...new FleetJwtAuthHeaders(),
      },
    })
  ).pipe(selectData(driverPagedCollectionSchema));
}
